module.exports = __webpack_public_path__ + "static/media/ic_nav_payment.3bf97616.svg";